import { getDocumentData } from "../../../helpers";

import createTodoResolvedData from "../data/todos/createTodoResolvedData";
import updateTodo from "../updateTodo";

export default async function resolveTodo(firebase, { todo, user }) {
	const existingTodo = await getDocumentData(todo.ref);

	if (existingTodo && !existingTodo.resolved?.status) {
		await updateTodo(todo.ref, {
			resolved: createTodoResolvedData(firebase, { user }),
		});
	}
}
